export const NOTIFICACIONES_PAGE_LOAD = 'NOTIFICACIONES_PAGE_LOAD';
export const NOTIFICACIONES_PAGE_LOAD_SUCCESS = 'NOTIFICACIONES_PAGE_LOAD_SUCCESS';
export const NOTIFICACIONES_PAGE_LOAD_FAIL = 'NOTIFICACIONES_PAGE_LOAD_FAIL';

export function isNotificacionesPageLoaded(globalState) {
  return globalState.notificaciones && globalState.notificaciones.loaded;
}

export function loadNotificacionesPage() {
  return {
    types: [NOTIFICACIONES_PAGE_LOAD, NOTIFICACIONES_PAGE_LOAD_SUCCESS, NOTIFICACIONES_PAGE_LOAD_FAIL],
    promise: client => client.get('/api/notificaciones'), // params not used, just shown as demonstration
  };
}
